import { createRouter, createWebHistory } from "vue-router";  
import SignIn from "../project/Auth/Cover.vue";    

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "signIn",
  }, 
  {
    path: "/signIn",
    name: "SignIn",
    component: SignIn
  } 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
